
import { Color } from '@/colors/colors';
import { SubCategoryType } from '@/colors/componentCategories';
import { Material } from '@/colors/materials';
import { ComponentPictureLoader } from '@/loaders/ComponentPictureLoader';
import { Perspective } from '@/types/Perspective';
import Vue from 'vue';
import ColorPickerComponent from './ColorPickerComponent.vue';

interface HoverObject {
  color: Color;
  material: Material;
}

export default Vue.extend({
  name: 'SubCategoryComponent',
  components: {
    ColorPickerComponent,
  },
  props: {
    displayText: String,
    types: {
      required: true,
      type: Array as () => SubCategoryType[]
    },
    categoryName: String,
    parentCategory: String,
    showBack: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      uuid: Math.random().toString().slice(2),
    };
  },
  computed: {
    perspective(): Perspective {
      return this.$store.getters.getPerspective
    },
  },
  methods: {
    colorChange(component: string, obj: HoverObject) {
      this.$store.commit('setColor', { name: component, newColor: obj.color, material: obj.material });
    },
    hover(component: string, obj: HoverObject) {
      const image = new Image();
      image.src = ComponentPictureLoader.load(component, obj.color, this.perspective, ComponentPictureLoader.getFileSystemSuffixForMaterial(obj.material))
    },
    collapseClicked() {
        if (this.showBack) {
            this.$store.commit('setPerspective', Perspective.BACK)
        } else {
            this.$store.commit('setPerspective', Perspective.FRONT)
        }
    }
  },
});
